import { NavItem } from './general.known.routes';

export enum ParametricKnownItemId {
  PARAMETRIC = 1,
  HOSPITALS,
  KNOW_NOVELTIES,
  PARAMETRIC_LIST,
  REFERRAL_TRACKING,
  EVENT_TYPES,
  GENERAL_PARAMS,
  FILE_SIZE,
  REFERENCES_COUNTER_REFERENCES,
  REASON_CANCELLATION,
  EVENT_TYPES_REFERENCES,
  PATHOLOGIES,
  REFERRAL_REASON,
  VALUATION_TM_PORTALS,
  TM_PORTALS,
  FINAL_CONDUCT,
  INCIDENT_REASON,
  CONDUCT,
  ATTENTION,
  CUTOFF_DATE,
  RETENTION_TIME,
  APP_AMBULANCES,
  SUPPLIES,
  RESOURCE_TYPE,
  PREOP_SUPPLIES_MEDICATION,
  BIOMEDICAL_EQUIPMENT,
  PREOP_BIOMEDICAL_EQUIPMENT,
  CUPS_CODES,
  REFERENCES_SERVICES,
  GENERAL_TIME,
  PREOP_DRIVER,
  HUMAN_TALENT_EDUCATION,
  PUBLIC_ENTITY,
  CREATE_PUBLIC_ENTITY,
  EDIT_PUBLIC_ENTITY,
  LEVEL_EDUCATION,
  COUNTRIES,
  SEXUAL_ORIENTATION,
  CORE_PARAMETRIC,
  ETHNICITY,
  POPULATION_OF_INTEREST,
  SITES,
  SPECIAL_CONDITION,
  ETNIA,
  DISABILITY,
  GENDER,
  PUPIL_SHAPE,
  PARAMETRIC_PROVIDER,
  SOAT_ENTITY,
  VEHICLE_BRAND,
  FUEL,
  VEHICLE_CLASS,
  RIM,
  AUTOMOTIVE_DIAGNOSTIC_CENTER,
  PROFESSIONS_AND_OCCUPATIONS,
  EDUCATION_PARAMETERS,
  WITHOUT_TRANSFER,
  MAP_INCIDENT_GROUP,
  MAPS_PARAMETRIC,
  VEHICLE_ELEMENTS,
  INVENTORY_INIT_BIOMEDICAL_EQUIPMENT,
  INVENTORY_INIT_VEHICLE,
  INVENTORY_INIT_MEDICATIONS_SUPPLIES,
  CONSECUTIVE_APH_REGISTER,
}

const simpleTransformer = (input: NavItem): NavItem & { type: 'parametric' } => {
  return {
    ...input,
    type: 'parametric',
  };
};

export const ParametricKnownRoutes = (k: ParametricKnownItemId): NavItem => {
  return JSON.parse(JSON.stringify(options[k]));
};

const options: {
  [k in ParametricKnownItemId]: NavItem & { type: 'parametric' };
} = {
  [ParametricKnownItemId.PARAMETRIC]: simpleTransformer({
    id: ParametricKnownItemId.PARAMETRIC,
    displayName: 'Paramétricas',
    iconName: 'parametrics',
    route: '/home/parametric/hospitals',
  }),
  [ParametricKnownItemId.HOSPITALS]: simpleTransformer({
    id: ParametricKnownItemId.HOSPITALS,
    displayName: 'Hospitales',
    iconName: 'hospital',
    route: '/home/parametric/hospitals',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.KNOW_NOVELTIES]: simpleTransformer({
    id: ParametricKnownItemId.KNOW_NOVELTIES,
    displayName: 'Tipo de Novedades',
    iconName: 'hospital',
    route: '/home/parametric/hospitals/kinds-novelties',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.PARAMETRIC_LIST]: simpleTransformer({
    id: ParametricKnownItemId.PARAMETRIC_LIST,
    displayName: 'Paramétricas',
    iconName: 'parametrics',
    route: '/home/parametric/list',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.REFERRAL_TRACKING]: simpleTransformer({
    id: ParametricKnownItemId.REFERRAL_TRACKING,
    displayName: 'Seguimiento de Referencias',
    iconName: 'phone-forwarded',
    route: '/home/parametric/referral-tracking',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.EVENT_TYPES]: simpleTransformer({
    id: ParametricKnownItemId.EVENT_TYPES,
    displayName: 'Tipo de Evento',
    iconName: 'news',
    route: '/home/parametric/referral-tracking/event-types',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.GENERAL_PARAMS]: simpleTransformer({
    id: ParametricKnownItemId.GENERAL_PARAMS,
    displayName: 'Parámetros Generales',
    iconName: 'settings-applications',
    route: '/home/parametric/general-params',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.FILE_SIZE]: simpleTransformer({
    id: ParametricKnownItemId.FILE_SIZE,
    displayName: 'Parámetros Generales',
    iconName: 'settings-applications',
    route: '/home/parametric/general-params',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.REFERENCES_COUNTER_REFERENCES]: simpleTransformer({
    id: ParametricKnownItemId.REFERENCES_COUNTER_REFERENCES,
    displayName: 'Referencia y Contrarreferencia',
    iconName: 'sync',
    route: '/home/parametric/references-counter-references',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.REASON_CANCELLATION]: simpleTransformer({
    id: ParametricKnownItemId.REASON_CANCELLATION,
    displayName: 'Motivo de Cancelación',
    iconName: 'cancel',
    route: '/home/parametric/references-counter-references/reason-cancellation',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.EVENT_TYPES_REFERENCES]: simpleTransformer({
    id: ParametricKnownItemId.EVENT_TYPES_REFERENCES,
    displayName: 'Tipo de Evento',
    iconName: 'news',
    route: '/home/parametric/references-counter-references/event-types',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.PATHOLOGIES]: simpleTransformer({
    id: ParametricKnownItemId.PATHOLOGIES,
    displayName: 'Patologías',
    iconName: 'pathologies',
    route: '/home/parametric/references-counter-references/pathologies',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.REFERRAL_REASON]: simpleTransformer({
    id: ParametricKnownItemId.REFERRAL_REASON,
    displayName: 'Motivo de la Remisión',
    iconName: 'trasfer-station',
    route: '/home/parametric/references-counter-references/referral-reason',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.RETENTION_TIME]: simpleTransformer({
    id: ParametricKnownItemId.RETENTION_TIME,
    displayName: 'Parámetros Generales',
    iconName: 'settings-applications',
    route: '/home/parametric/general-params',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.VALUATION_TM_PORTALS]: simpleTransformer({
    id: ParametricKnownItemId.VALUATION_TM_PORTALS,
    displayName: 'Valoración Portales de TM',
    iconName: 'transmilenio',
    route: '/home/parametric/valuation-tm-portals',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.TM_PORTALS]: simpleTransformer({
    id: ParametricKnownItemId.TM_PORTALS,
    displayName: 'Portales de Transmilenio',
    iconName: 'bus',
    route: '/home/parametric/valuation-tm-portals/tm-portals',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.FINAL_CONDUCT]: simpleTransformer({
    id: ParametricKnownItemId.FINAL_CONDUCT,
    displayName: 'Conducta final',
    iconName: 'final-conduct',
    route: '/home/parametric/hospitals/final-conduct',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.HUMAN_TALENT_EDUCATION]: simpleTransformer({
    id: ParametricKnownItemId.HUMAN_TALENT_EDUCATION,
    displayName: 'Formación al talento humano',
    iconName: 'academic-cap',
    route: '/home/parametric/human-talent-education',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.PUBLIC_ENTITY]: simpleTransformer({
    id: ParametricKnownItemId.PUBLIC_ENTITY,
    displayName: 'ENTIDADES PÚBLICAS',
    iconName: 'corporate',
    route: '/home/parametric/human-talent-education/public-entities',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.CREATE_PUBLIC_ENTITY]: simpleTransformer({
    id: ParametricKnownItemId.CREATE_PUBLIC_ENTITY,
    displayName: 'Formación al talento humano',
    iconName: 'academic-cap',
    route: '/home/parametric/human-talent-education',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.EDIT_PUBLIC_ENTITY]: simpleTransformer({
    id: ParametricKnownItemId.EDIT_PUBLIC_ENTITY,
    displayName: 'Formación al talento humano',
    iconName: 'academic-cap',
    route: '/home/parametric/human-talent-education',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.PROFESSIONS_AND_OCCUPATIONS]: simpleTransformer({
    id: ParametricKnownItemId.PROFESSIONS_AND_OCCUPATIONS,
    displayName: 'Profesiones y ocupaciones',
    iconName: 'work-bag',
    route: '/home/parametric/human-talent-education/professions-and-occupations',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.EDUCATION_PARAMETERS]: simpleTransformer({
    id: ParametricKnownItemId.EDUCATION_PARAMETERS,
    displayName: 'Parámetros de formación',
    iconName: 'local-library',
    route: '/home/parametric/human-talent-education/education-parameters',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.INCIDENT_REASON]: simpleTransformer({
    id: ParametricKnownItemId.INCIDENT_REASON,
    displayName: 'Causa del Incidente',
    iconName: 'alert',
    route: '/home/parametric/valuation-tm-portals/incident-cause',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.CONDUCT]: simpleTransformer({
    id: ParametricKnownItemId.CONDUCT,
    displayName: 'Conducta',
    iconName: 'trasfer-station',
    route: '/home/parametric/valuation-tm-portals/conduct',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.ATTENTION]: simpleTransformer({
    id: ParametricKnownItemId.ATTENTION,
    displayName: 'Atención Prestada',
    iconName: 'people',
    route: '/home/parametric/valuation-tm-portals/attention',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.CUTOFF_DATE]: simpleTransformer({
    id: ParametricKnownItemId.CUTOFF_DATE,
    displayName: 'Fecha De Corte',
    iconName: 'calendar-2',
    route: '/home/parametric/valuation-tm-portals/cutoff-date',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.APP_AMBULANCES]: simpleTransformer({
    id: ParametricKnownItemId.APP_AMBULANCES,
    displayName: 'App Ambulancias',
    tabName: 'APP AMBULANCIAS',
    iconName: 'cellphone',
    route: '/home/parametric/app-ambulance',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.SUPPLIES]: simpleTransformer({
    id: ParametricKnownItemId.SUPPLIES,
    displayName: 'Homologación código Insumos y Medicamentos',
    tabName: 'HOMOLOGACIÓN CÓDIGO INSUMOS Y MEDICAMENTOS',
    iconName: 'burger-menu',
    route: '/home/parametric/app-ambulance/supplies',
    parentModule: 'parametric',
  }),
  /*  [ParametricKnownItemId.CREATE_EDIT_SUPPLIES]: simpleTransformer({
      id: ParametricKnownItemId.CREATE_EDIT_SUPPLIES,
      displayName: 'Homologación código Insumos y Medicamentos',
      tabName: 'NUEVO',
      iconName: 'add-circle',
      route: '/home/parametric/app-ambulance/supplies/add',
      parentModule: 'parametric',
    }),*/
  [ParametricKnownItemId.RESOURCE_TYPE]: simpleTransformer({
    id: ParametricKnownItemId.RESOURCE_TYPE,
    displayName: 'Configuración general App por tipo de Recurso',
    tabName: 'CONFIGURACIÓN GENERAL APP POR TIPO DE RECURSO',
    iconName: 'burger-menu',
    route: '/home/parametric/app-ambulance/resource-type',
    parentModule: 'parametrics',
  }),
  [ParametricKnownItemId.PREOP_SUPPLIES_MEDICATION]: simpleTransformer({
    id: ParametricKnownItemId.PREOP_SUPPLIES_MEDICATION,
    displayName: 'Pre operacional Insumos y Medicamentos',
    tabName: 'PRE OPERACIONAL INSUMOS Y MEDICAMENTOS',
    iconName: 'burger-menu',
    route: '/home/parametric/app-ambulance/preop-supplies-medication',
    parentModule: 'parametrics',
  }),
  [ParametricKnownItemId.BIOMEDICAL_EQUIPMENT]: simpleTransformer({
    id: ParametricKnownItemId.BIOMEDICAL_EQUIPMENT,
    displayName: 'Homologación código Equipos Biomédicos',
    tabName: 'HOMOLOGACIÓN CÓDIGO EQUIPOS BIOMÉDICOS',
    iconName: 'burger-menu',
    route: '/home/parametric/app-ambulance/biomedical-equipment',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.VEHICLE_ELEMENTS]: simpleTransformer({
    id: ParametricKnownItemId.VEHICLE_ELEMENTS,
    displayName: 'Homologación código Elementos Vehículo',
    tabName: 'HOMOLOGACIÓN CÓDIGO ELEMENTOS VEHÍCULO',
    iconName: 'burger-menu',
    route: '/home/parametric/app-ambulance/vehicle-element',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.PREOP_BIOMEDICAL_EQUIPMENT]: simpleTransformer({
    id: ParametricKnownItemId.PREOP_BIOMEDICAL_EQUIPMENT,
    displayName: 'Pre operacional Equipos Biomédicos',
    tabName: 'PRE OPERACIONAL EQUIPOS BIOMÉDICOS',
    iconName: 'burger-menu',
    route: '/home/parametric/app-ambulance/preop-biomedical-equipment',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.CUPS_CODES]: simpleTransformer({
    id: ParametricKnownItemId.CUPS_CODES,
    displayName: 'Códigos CUPS',
    iconName: 'cups-codes',
    route: 'home/parametric/references-counter-references/cups-codes',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.REFERENCES_SERVICES]: simpleTransformer({
    id: ParametricKnownItemId.REFERENCES_SERVICES,
    displayName: 'Servicios',
    iconName: 'services',
    route: 'home/parametric/references-counter-references/references-services',
  }),
  [ParametricKnownItemId.GENERAL_TIME]: simpleTransformer({
    id: ParametricKnownItemId.GENERAL_TIME,
    displayName: 'configuración General Tiempos App',
    tabName: 'CONFIGURACIÓN GENERAL TIEMPOS APP',
    iconName: 'burger-menu',
    route: '/home/parametric/app-ambulance/general-time',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.PREOP_DRIVER]: simpleTransformer({
    id: ParametricKnownItemId.PREOP_DRIVER,
    displayName: 'Pre operacional Conductor',
    tabName: 'PRE OPERACIONAL CONDUCTOR',
    iconName: 'burger-menu',
    route: '/home/parametric/app-ambulance/preop-driver',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.LEVEL_EDUCATION]: simpleTransformer({
    id: ParametricKnownItemId.LEVEL_EDUCATION,
    displayName: 'Nivel de formación',
    iconName: 'education',
    route: '/home/parametric/hospitals/level-education',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.COUNTRIES]: simpleTransformer({
    id: ParametricKnownItemId.COUNTRIES,
    displayName: 'Paises',
    iconName: 'public_black',
    route: '/home/parametric/general-params/countries',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.CORE_PARAMETRIC]: simpleTransformer({
    id: ParametricKnownItemId.CORE_PARAMETRIC,
    displayName: 'Core',
    iconName: 'alert',
    route: '/home/parametric/core',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.ETHNICITY]: simpleTransformer({
    id: ParametricKnownItemId.ETHNICITY,
    displayName: 'Pertenencia Étnica',
    iconName: 'groups',
    route: '/home/parametric/core/ethnicity',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.POPULATION_OF_INTEREST]: simpleTransformer({
    id: ParametricKnownItemId.POPULATION_OF_INTEREST,
    displayName: 'Población de Interés',
    iconName: 'supervised_user',
    route: '/home/parametric/core/population_interest',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.SITES]: simpleTransformer({
    id: ParametricKnownItemId.SITES,
    displayName: 'Sitios',
    iconName: 'sites',
    route: '/home/parametric/core/sites',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.PARAMETRIC_PROVIDER]: simpleTransformer({
    id: ParametricKnownItemId.PARAMETRIC_PROVIDER,
    displayName: 'Prestadores',
    iconName: 'providers',
    route: '/home/parametric/providers',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.SOAT_ENTITY]: simpleTransformer({
    id: ParametricKnownItemId.SOAT_ENTITY,
    displayName: 'Entidad que expide el SOAT',
    iconName: 'soat',
    route: '/home/parametric/providers/soat-entity',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.VEHICLE_BRAND]: simpleTransformer({
    id: ParametricKnownItemId.VEHICLE_BRAND,
    displayName: 'Marca',
    iconName: 'vehicle-brand',
    route: '/home/parametric/providers/vehicle-brand',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.SEXUAL_ORIENTATION]: simpleTransformer({
    id: ParametricKnownItemId.SEXUAL_ORIENTATION,
    displayName: 'Orientación Sexual',
    tabName: 'ORIENTACIÓN SEXUAL',
    iconName: 'orientation-sexual',
    route: '/home/parametric/human-talent-education/sexual-orientation',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.SPECIAL_CONDITION]: simpleTransformer({
    id: ParametricKnownItemId.SPECIAL_CONDITION,
    displayName: 'Condición especial',
    iconName: 'diversity_2',
    route: '/home/parametric/general-params/special-condition',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.ETNIA]: simpleTransformer({
    id: ParametricKnownItemId.ETNIA,
    displayName: 'Etnia',
    iconName: 'groups',
    route: '/home/parametric/general-params/etnia',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.DISABILITY]: simpleTransformer({
    id: ParametricKnownItemId.DISABILITY,
    displayName: 'Discapacidad',
    iconName: 'accessible',
    route: '/home/parametric/general-params/disability',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.GENDER]: simpleTransformer({
    id: ParametricKnownItemId.GENDER,
    displayName: 'Género',
    iconName: 'gender',
    route: '/home/parametric/general-params/gender',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.PUPIL_SHAPE]: simpleTransformer({
    id: ParametricKnownItemId.PUPIL_SHAPE,
    displayName: 'Forma de la pupila',
    iconName: 'visibility',
    route: '/home/parametric/core/pupil-shape',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.FUEL]: simpleTransformer({
    id: ParametricKnownItemId.FUEL,
    displayName: 'Combustible',
    iconName: 'local-gas-station',
    route: '/home/parametric/providers/fuel',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.VEHICLE_CLASS]: simpleTransformer({
    id: ParametricKnownItemId.VEHICLE_CLASS,
    displayName: 'Clase de Vehículo',
    iconName: 'directions-car',
    route: '/home/parametric/providers/vehicle-class',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.RIM]: simpleTransformer({
    id: ParametricKnownItemId.RIM,
    displayName: 'Rin',
    iconName: 'rin',
    route: '/home/parametric/providers/rim',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.AUTOMOTIVE_DIAGNOSTIC_CENTER]: simpleTransformer({
    id: ParametricKnownItemId.AUTOMOTIVE_DIAGNOSTIC_CENTER,
    displayName: 'Centro de Diagnóstico Automotor',
    iconName: 'car-repair',
    route: '/home/parametric/providers/automotive-diagnostic-center',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.WITHOUT_TRANSFER]: simpleTransformer({
    id: ParametricKnownItemId.WITHOUT_TRANSFER,
    displayName: 'Motivo de No traslado',
    iconName: 'without-transfer',
    route: '/home/parametric/core/without-transfer',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.MAP_INCIDENT_GROUP]: simpleTransformer({
    id: ParametricKnownItemId.MAP_INCIDENT_GROUP,
    displayName: 'Grupo de incidentes',
    iconName: 'incident-group',
    route: '/home/parametric/maps/incident-group',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.MAPS_PARAMETRIC]: simpleTransformer({
    id: ParametricKnownItemId.MAPS_PARAMETRIC,
    displayName: 'Mapas',
    iconName: 'map',
    route: '/home/parametric/maps',
    parentModule: 'parametric',
  }),
  [ParametricKnownItemId.INVENTORY_INIT_BIOMEDICAL_EQUIPMENT]: simpleTransformer({
    id: ParametricKnownItemId.INVENTORY_INIT_BIOMEDICAL_EQUIPMENT,
    displayName: 'Saldo Inicial Equipos biomédicos',
    tabName: 'SALDO INICIAL EQUIPOS BIOMÉDICOS',
    iconName: 'burger-menu',
    route: '/home/parametric/app-ambulance/balance-init-biomedical-equipment',
  }),
  [ParametricKnownItemId.INVENTORY_INIT_VEHICLE]: simpleTransformer({
    id: ParametricKnownItemId.INVENTORY_INIT_VEHICLE,
    displayName: 'Saldo Inicial Insumos Vehículo',
    tabName: 'SALDO INICIAL INSUMOS VEHÍCULO',
    iconName: 'burger-menu',
    route: '/home/parametric/app-ambulance/balance-init-vehicle',
  }),
  [ParametricKnownItemId.INVENTORY_INIT_MEDICATIONS_SUPPLIES]: simpleTransformer({
    id: ParametricKnownItemId.INVENTORY_INIT_MEDICATIONS_SUPPLIES,
    displayName: 'Saldo Inicial Medicamentos e Insumos',
    tabName: 'SALDO INICIAL MEDICAMENTOS E INSUMOS',
    iconName: 'burger-menu',
    route: '/home/parametric/app-ambulance/balance-initial-medications-supplies',
  }),
  [ParametricKnownItemId.CONSECUTIVE_APH_REGISTER]: simpleTransformer({
    id: ParametricKnownItemId.CONSECUTIVE_APH_REGISTER,
    displayName: 'CONSECUTIVO REGISTRO APH',
    tabName: 'CONSECUTIVO REGISTRO APH',
    iconName: 'consecutive',
    route: '/home/parametric/app-ambulance/consecutive-register',
  }),
};
